/* ==========================================================================
   Mereni pasu produktu na rozcestnicich receptu (snippets/recepty-produkty.liquid)
   Udalosti jdou primo pres gtag do GA4 G-JSQ5TT7D3M, stejne jako u listy
   Do kosiku (sticky_*). Bez souhlasu s analytickymi cookies gtag nic neposle.

     hub_band_view       pas se ukazal (aspon z poloviny), jednou za nacteni
     hub_product_click   klik na obrazek nebo nazev produktu
     hub_atc_click       klik na Do kosiku
     hub_atc_success     sablona potvrdila pridani (add-to-cart:finished, do 15 s)
     hub_collection_click klik na kolekci v pasu kolekci nebo na Cela policka

   Spolecne parametry: item_list_name (nazev rozcestniku), band_index,
   band_source (vlastni / handle kolekce / kolekce).
   Samotne pridani do kosiku dela sablona (product-card-script.liquid),
   tenhle soubor jen meri. Kontrolni znacka: RP-HUB-V1
   ========================================================================== */
(function () {
  var pasy = document.querySelectorAll('.landing-page-content .rp-pas');
  if (!pasy.length) return;
  var GA4 = 'G-JSQ5TT7D3M';
  var pending = null;

  function track(name, params) {
    try {
      if (typeof window.gtag !== 'function') return;
      params.send_to = GA4;
      window.gtag('event', name, params);
    } catch (e) {}
  }

  function pasInfo(pas) {
    return {
      item_list_name: pas.getAttribute('data-rp-seznam') || document.title,
      band_index: pas.getAttribute('data-rp-pas') || '',
      band_source: pas.getAttribute('data-rp-zdroj') || 'kolekce'
    };
  }

  function itemInfo(li) {
    var p = pasInfo(li.closest('.rp-pas'));
    var cena = parseFloat(li.getAttribute('data-rp-cena')) || 0;
    p.item_id = li.getAttribute('data-rp-sku') || '';
    p.item_name = li.getAttribute('data-rp-nazev') || '';
    p.index = parseInt(li.getAttribute('data-rp-pozice'), 10) || 0;
    p.value = cena;
    p.currency = 'CZK';
    return p;
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var p = pasInfo(e.target);
        p.items_count = e.target.querySelectorAll('.rp-item, .rp-col').length;
        track('hub_band_view', p);
      });
    }, { threshold: 0.5 });
    Array.prototype.forEach.call(pasy, function (p) { io.observe(p); });
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var atc = t.closest('.rp-pas [data-rp-atc]');
    if (atc) {
      var li = atc.closest('.rp-item');
      if (!li) return;
      var p = itemInfo(li);
      p.quantity = 1;
      track('hub_atc_click', p);
      pending = { params: p, t: Date.now() };
      return;
    }
    var klik = t.closest('.rp-pas [data-rp-klik]');
    if (klik) {
      var li2 = klik.closest('.rp-item');
      if (li2) track('hub_product_click', itemInfo(li2));
      return;
    }
    var kol = t.closest('.rp-pas .rp-col, .rp-pas [data-rp-policka]');
    if (kol) {
      var p3 = pasInfo(kol.closest('.rp-pas'));
      p3.collection = kol.getAttribute('data-rp-kolekce') || p3.band_source;
      p3.index = parseInt(kol.getAttribute('data-rp-pozice'), 10) || 0;
      track('hub_collection_click', p3);
    }
  }, true);

  /* ---- ZIVE CENY (stejny princip jako LP-LIVE-PRICES-V1 v landing-page.js) ----
     Liquid cenu vypisuje pri vykresleni, ale stranka muze byt v cache.
     Tady se pri zobrazeni dotahne /products/<handle>.js a kdyz se cena,
     puvodni cena nebo dostupnost lisi, text se prepise. Cena za jednotku
     se prepocita stejnym vzorcem jako snippets/unit-price-value.liquid
     (CZK na 1 desetinne misto, zaokrouhleno). Pri chybe zustava cena
     z Liquidu. Vysledek 10 minut v sessionStorage. */
  function kc(cents) {
    return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč';
  }
  function jednotka(cents, units, base) {
    var u = parseFloat(units), b = parseFloat(base);
    if (!(u > 0) || !(b > 0)) return null;
    var s = Math.round(cents / u * b * 10 / 100);
    return Math.floor(s / 10) + ',' + (s % 10) + ' Kč';
  }
  function zivaCena(li, v) {
    var cena = li.querySelector('.rp-cena');
    if (cena && typeof v.price === 'number') {
      var t = kc(v.price);
      if (cena.textContent.replace(/\s/g, '') !== t.replace(/\s/g, '')) cena.textContent = t;
      li.setAttribute('data-rp-cena', (v.price / 100).toFixed(2));
    }
    var puv = li.querySelector('.rp-puv');
    if (puv) {
      if (v.compare_at_price && v.compare_at_price > v.price) { puv.textContent = kc(v.compare_at_price); puv.hidden = false; }
      else puv.hidden = true;
    }
    var j = li.querySelector('.rp-jedn');
    var jt = jednotka(v.price, li.getAttribute('data-rp-units'), li.getAttribute('data-rp-base'));
    if (j && jt) j.textContent = jt + ' / ' + li.getAttribute('data-rp-base') + ' ' + li.getAttribute('data-rp-type');
    var btn = li.querySelector('[data-rp-atc]');
    if (btn) {
      btn.disabled = !v.available;
      var lbl = btn.querySelector('span');
      if (lbl) lbl.textContent = v.available ? 'Do košíku' : 'Vyprodáno';
    }
    li.setAttribute('data-live-price', '1');
  }
  if (window.fetch) {
    Array.prototype.forEach.call(document.querySelectorAll('.rp-pas .rp-item[data-rp-handle]'), function (li) {
      var h = li.getAttribute('data-rp-handle'), vid = li.getAttribute('data-rp-varianta');
      var key = 'rpVar:' + vid, cached = null;
      try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
      if (cached && Date.now() - cached.t < 600000) { zivaCena(li, cached.v); return; }
      fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) {
          var v = null;
          (p.variants || []).forEach(function (x) { if (String(x.id) === vid) v = x; });
          if (!v) return;
          v = { price: v.price, compare_at_price: v.compare_at_price, available: v.available };
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {}
          zivaCena(li, v);
        })
        .catch(function () {});
    });
  }

  document.addEventListener('add-to-cart:finished', function (ev) {
    if (!pending || Date.now() - pending.t > 15000) { pending = null; return; }
    var ok = ev && ev.detail && ev.detail.success;
    if (ok) track('hub_atc_success', pending.params);
    pending = null;
  });
})();
